import type { ErrorType } from '../../shared/lib/axios/client'
import type {
  AddFormPagesDto,
  CheckFormDto,
  CreateFormDto,
  FormControllerFindAllParams,
  FormControllerFindRevisionsParams,
  FormDto,
  FormRevisionDto,
  PaginatedFormDto,
  PaginatedFormRevisionDto,
  PatchFormDto,
  RollbackFormDto,
  UpdateFormDto,
  UserClientFormDto,
  ValidationResult,
} from '.././types'
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query'

/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Detelio API specification
 * openAPI specification for Detelio API
 * OpenAPI spec version: 1.0
 */
import { useMutation, useQuery } from '@tanstack/react-query'

import { axiosClient } from '../../shared/lib/axios/client'

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1]

export const formControllerFindById = (
  id: string,
  options?: SecondParameter<typeof axiosClient>,
  signal?: AbortSignal,
) => {
  return axiosClient<FormDto>(
    { url: `https://test-api.detelio.ai/form/${id}`, method: 'GET', signal },
    options,
  )
}

export const getFormControllerFindByIdQueryKey = (id?: string) => {
  return [`https://test-api.detelio.ai/form/${id}`] as const
}

export const getFormControllerFindByIdQueryOptions = <
  TData = Awaited<ReturnType<typeof formControllerFindById>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof formControllerFindById>>, TError, TData>>
    request?: SecondParameter<typeof axiosClient>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getFormControllerFindByIdQueryKey(id)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof formControllerFindById>>> = ({ signal }) =>
    formControllerFindById(id, requestOptions, signal)

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof formControllerFindById>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FormControllerFindByIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof formControllerFindById>>
>
export type FormControllerFindByIdQueryError = ErrorType<unknown>

export function useFormControllerFindById<
  TData = Awaited<ReturnType<typeof formControllerFindById>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof formControllerFindById>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof formControllerFindById>>,
          TError,
          Awaited<ReturnType<typeof formControllerFindById>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof axiosClient>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFormControllerFindById<
  TData = Awaited<ReturnType<typeof formControllerFindById>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof formControllerFindById>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof formControllerFindById>>,
          TError,
          Awaited<ReturnType<typeof formControllerFindById>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof axiosClient>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFormControllerFindById<
  TData = Awaited<ReturnType<typeof formControllerFindById>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof formControllerFindById>>, TError, TData>>
    request?: SecondParameter<typeof axiosClient>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useFormControllerFindById<
  TData = Awaited<ReturnType<typeof formControllerFindById>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof formControllerFindById>>, TError, TData>>
    request?: SecondParameter<typeof axiosClient>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getFormControllerFindByIdQueryOptions(id, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  query.queryKey = queryOptions.queryKey

  return query
}

export const formControllerUpdate = (
  id: string,
  updateFormDto: UpdateFormDto,
  options?: SecondParameter<typeof axiosClient>,
) => {
  return axiosClient<FormDto>(
    {
      url: `https://test-api.detelio.ai/form/${id}`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: updateFormDto,
    },
    options,
  )
}

export const getFormControllerUpdateMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof formControllerUpdate>>,
    TError,
    { id: string; data: UpdateFormDto },
    TContext
  >
  request?: SecondParameter<typeof axiosClient>
}): UseMutationOptions<
  Awaited<ReturnType<typeof formControllerUpdate>>,
  TError,
  { id: string; data: UpdateFormDto },
  TContext
> => {
  const mutationKey = ['formControllerUpdate']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof formControllerUpdate>>,
    { id: string; data: UpdateFormDto }
  > = (props) => {
    const { id, data } = props ?? {}

    return formControllerUpdate(id, data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type FormControllerUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof formControllerUpdate>>>
export type FormControllerUpdateMutationBody = UpdateFormDto
export type FormControllerUpdateMutationError = ErrorType<unknown>

export const useFormControllerUpdate = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof formControllerUpdate>>,
      TError,
      { id: string; data: UpdateFormDto },
      TContext
    >
    request?: SecondParameter<typeof axiosClient>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof formControllerUpdate>>,
  TError,
  { id: string; data: UpdateFormDto },
  TContext
> => {
  const mutationOptions = getFormControllerUpdateMutationOptions(options)

  return useMutation(mutationOptions, queryClient)
}
export const formControllerDeleteForm = (id: string, options?: SecondParameter<typeof axiosClient>) => {
  return axiosClient<void>({ url: `https://test-api.detelio.ai/form/${id}`, method: 'DELETE' }, options)
}

export const getFormControllerDeleteFormMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof formControllerDeleteForm>>,
    TError,
    { id: string },
    TContext
  >
  request?: SecondParameter<typeof axiosClient>
}): UseMutationOptions<
  Awaited<ReturnType<typeof formControllerDeleteForm>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['formControllerDeleteForm']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof formControllerDeleteForm>>, { id: string }> = (
    props,
  ) => {
    const { id } = props ?? {}

    return formControllerDeleteForm(id, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type FormControllerDeleteFormMutationResult = NonNullable<
  Awaited<ReturnType<typeof formControllerDeleteForm>>
>

export type FormControllerDeleteFormMutationError = ErrorType<unknown>

export const useFormControllerDeleteForm = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof formControllerDeleteForm>>,
      TError,
      { id: string },
      TContext
    >
    request?: SecondParameter<typeof axiosClient>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof formControllerDeleteForm>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getFormControllerDeleteFormMutationOptions(options)

  return useMutation(mutationOptions, queryClient)
}
export const formControllerFindAll = (
  params?: FormControllerFindAllParams,
  options?: SecondParameter<typeof axiosClient>,
  signal?: AbortSignal,
) => {
  return axiosClient<PaginatedFormDto>(
    { url: `https://test-api.detelio.ai/form`, method: 'GET', params, signal },
    options,
  )
}

export const getFormControllerFindAllQueryKey = (params?: FormControllerFindAllParams) => {
  return [`https://test-api.detelio.ai/form`, ...(params ? [params] : [])] as const
}

export const getFormControllerFindAllQueryOptions = <
  TData = Awaited<ReturnType<typeof formControllerFindAll>>,
  TError = ErrorType<unknown>,
>(
  params?: FormControllerFindAllParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof formControllerFindAll>>, TError, TData>>
    request?: SecondParameter<typeof axiosClient>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getFormControllerFindAllQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof formControllerFindAll>>> = ({ signal }) =>
    formControllerFindAll(params, requestOptions, signal)

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof formControllerFindAll>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FormControllerFindAllQueryResult = NonNullable<Awaited<ReturnType<typeof formControllerFindAll>>>
export type FormControllerFindAllQueryError = ErrorType<unknown>

export function useFormControllerFindAll<
  TData = Awaited<ReturnType<typeof formControllerFindAll>>,
  TError = ErrorType<unknown>,
>(
  params: undefined | FormControllerFindAllParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof formControllerFindAll>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof formControllerFindAll>>,
          TError,
          Awaited<ReturnType<typeof formControllerFindAll>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof axiosClient>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFormControllerFindAll<
  TData = Awaited<ReturnType<typeof formControllerFindAll>>,
  TError = ErrorType<unknown>,
>(
  params?: FormControllerFindAllParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof formControllerFindAll>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof formControllerFindAll>>,
          TError,
          Awaited<ReturnType<typeof formControllerFindAll>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof axiosClient>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFormControllerFindAll<
  TData = Awaited<ReturnType<typeof formControllerFindAll>>,
  TError = ErrorType<unknown>,
>(
  params?: FormControllerFindAllParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof formControllerFindAll>>, TError, TData>>
    request?: SecondParameter<typeof axiosClient>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useFormControllerFindAll<
  TData = Awaited<ReturnType<typeof formControllerFindAll>>,
  TError = ErrorType<unknown>,
>(
  params?: FormControllerFindAllParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof formControllerFindAll>>, TError, TData>>
    request?: SecondParameter<typeof axiosClient>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getFormControllerFindAllQueryOptions(params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  query.queryKey = queryOptions.queryKey

  return query
}

export const formControllerCreate = (
  createFormDto: CreateFormDto,
  options?: SecondParameter<typeof axiosClient>,
  signal?: AbortSignal,
) => {
  return axiosClient<FormDto>(
    {
      url: `https://test-api.detelio.ai/form`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createFormDto,
      signal,
    },
    options,
  )
}

export const getFormControllerCreateMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof formControllerCreate>>,
    TError,
    { data: CreateFormDto },
    TContext
  >
  request?: SecondParameter<typeof axiosClient>
}): UseMutationOptions<
  Awaited<ReturnType<typeof formControllerCreate>>,
  TError,
  { data: CreateFormDto },
  TContext
> => {
  const mutationKey = ['formControllerCreate']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof formControllerCreate>>,
    { data: CreateFormDto }
  > = (props) => {
    const { data } = props ?? {}

    return formControllerCreate(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type FormControllerCreateMutationResult = NonNullable<Awaited<ReturnType<typeof formControllerCreate>>>
export type FormControllerCreateMutationBody = CreateFormDto
export type FormControllerCreateMutationError = ErrorType<unknown>

export const useFormControllerCreate = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof formControllerCreate>>,
      TError,
      { data: CreateFormDto },
      TContext
    >
    request?: SecondParameter<typeof axiosClient>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof formControllerCreate>>,
  TError,
  { data: CreateFormDto },
  TContext
> => {
  const mutationOptions = getFormControllerCreateMutationOptions(options)

  return useMutation(mutationOptions, queryClient)
}
export const formControllerFindFormForUserClient = (
  id: string,
  options?: SecondParameter<typeof axiosClient>,
  signal?: AbortSignal,
) => {
  return axiosClient<UserClientFormDto>(
    { url: `https://test-api.detelio.ai/form/public/${id}`, method: 'GET', signal },
    options,
  )
}

export const getFormControllerFindFormForUserClientQueryKey = (id?: string) => {
  return [`https://test-api.detelio.ai/form/public/${id}`] as const
}

export const getFormControllerFindFormForUserClientQueryOptions = <
  TData = Awaited<ReturnType<typeof formControllerFindFormForUserClient>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof formControllerFindFormForUserClient>>, TError, TData>
    >
    request?: SecondParameter<typeof axiosClient>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getFormControllerFindFormForUserClientQueryKey(id)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof formControllerFindFormForUserClient>>> = ({
    signal,
  }) => formControllerFindFormForUserClient(id, requestOptions, signal)

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof formControllerFindFormForUserClient>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FormControllerFindFormForUserClientQueryResult = NonNullable<
  Awaited<ReturnType<typeof formControllerFindFormForUserClient>>
>
export type FormControllerFindFormForUserClientQueryError = ErrorType<unknown>

export function useFormControllerFindFormForUserClient<
  TData = Awaited<ReturnType<typeof formControllerFindFormForUserClient>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof formControllerFindFormForUserClient>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof formControllerFindFormForUserClient>>,
          TError,
          Awaited<ReturnType<typeof formControllerFindFormForUserClient>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof axiosClient>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFormControllerFindFormForUserClient<
  TData = Awaited<ReturnType<typeof formControllerFindFormForUserClient>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof formControllerFindFormForUserClient>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof formControllerFindFormForUserClient>>,
          TError,
          Awaited<ReturnType<typeof formControllerFindFormForUserClient>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof axiosClient>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFormControllerFindFormForUserClient<
  TData = Awaited<ReturnType<typeof formControllerFindFormForUserClient>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof formControllerFindFormForUserClient>>, TError, TData>
    >
    request?: SecondParameter<typeof axiosClient>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useFormControllerFindFormForUserClient<
  TData = Awaited<ReturnType<typeof formControllerFindFormForUserClient>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof formControllerFindFormForUserClient>>, TError, TData>
    >
    request?: SecondParameter<typeof axiosClient>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getFormControllerFindFormForUserClientQueryOptions(id, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  query.queryKey = queryOptions.queryKey

  return query
}

export const formControllerPatchKeys = (
  id: string,
  patchFormDto: PatchFormDto,
  options?: SecondParameter<typeof axiosClient>,
) => {
  return axiosClient<FormDto>(
    {
      url: `https://test-api.detelio.ai/form/${id}/keys`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: patchFormDto,
    },
    options,
  )
}

export const getFormControllerPatchKeysMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof formControllerPatchKeys>>,
    TError,
    { id: string; data: PatchFormDto },
    TContext
  >
  request?: SecondParameter<typeof axiosClient>
}): UseMutationOptions<
  Awaited<ReturnType<typeof formControllerPatchKeys>>,
  TError,
  { id: string; data: PatchFormDto },
  TContext
> => {
  const mutationKey = ['formControllerPatchKeys']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof formControllerPatchKeys>>,
    { id: string; data: PatchFormDto }
  > = (props) => {
    const { id, data } = props ?? {}

    return formControllerPatchKeys(id, data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type FormControllerPatchKeysMutationResult = NonNullable<
  Awaited<ReturnType<typeof formControllerPatchKeys>>
>
export type FormControllerPatchKeysMutationBody = PatchFormDto
export type FormControllerPatchKeysMutationError = ErrorType<unknown>

export const useFormControllerPatchKeys = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof formControllerPatchKeys>>,
      TError,
      { id: string; data: PatchFormDto },
      TContext
    >
    request?: SecondParameter<typeof axiosClient>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof formControllerPatchKeys>>,
  TError,
  { id: string; data: PatchFormDto },
  TContext
> => {
  const mutationOptions = getFormControllerPatchKeysMutationOptions(options)

  return useMutation(mutationOptions, queryClient)
}
export const formControllerAddPages = (
  id: string,
  addFormPagesDto: AddFormPagesDto,
  options?: SecondParameter<typeof axiosClient>,
  signal?: AbortSignal,
) => {
  return axiosClient<FormDto>(
    {
      url: `https://test-api.detelio.ai/form/${id}/pages`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: addFormPagesDto,
      signal,
    },
    options,
  )
}

export const getFormControllerAddPagesMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof formControllerAddPages>>,
    TError,
    { id: string; data: AddFormPagesDto },
    TContext
  >
  request?: SecondParameter<typeof axiosClient>
}): UseMutationOptions<
  Awaited<ReturnType<typeof formControllerAddPages>>,
  TError,
  { id: string; data: AddFormPagesDto },
  TContext
> => {
  const mutationKey = ['formControllerAddPages']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof formControllerAddPages>>,
    { id: string; data: AddFormPagesDto }
  > = (props) => {
    const { id, data } = props ?? {}

    return formControllerAddPages(id, data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type FormControllerAddPagesMutationResult = NonNullable<
  Awaited<ReturnType<typeof formControllerAddPages>>
>
export type FormControllerAddPagesMutationBody = AddFormPagesDto
export type FormControllerAddPagesMutationError = ErrorType<unknown>

export const useFormControllerAddPages = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof formControllerAddPages>>,
      TError,
      { id: string; data: AddFormPagesDto },
      TContext
    >
    request?: SecondParameter<typeof axiosClient>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof formControllerAddPages>>,
  TError,
  { id: string; data: AddFormPagesDto },
  TContext
> => {
  const mutationOptions = getFormControllerAddPagesMutationOptions(options)

  return useMutation(mutationOptions, queryClient)
}
export const formControllerCheckFormData = (
  id: string,
  checkFormDto: CheckFormDto,
  options?: SecondParameter<typeof axiosClient>,
  signal?: AbortSignal,
) => {
  return axiosClient<ValidationResult>(
    {
      url: `https://test-api.detelio.ai/form/${id}/check`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: checkFormDto,
      signal,
    },
    options,
  )
}

export const getFormControllerCheckFormDataMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof formControllerCheckFormData>>,
    TError,
    { id: string; data: CheckFormDto },
    TContext
  >
  request?: SecondParameter<typeof axiosClient>
}): UseMutationOptions<
  Awaited<ReturnType<typeof formControllerCheckFormData>>,
  TError,
  { id: string; data: CheckFormDto },
  TContext
> => {
  const mutationKey = ['formControllerCheckFormData']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof formControllerCheckFormData>>,
    { id: string; data: CheckFormDto }
  > = (props) => {
    const { id, data } = props ?? {}

    return formControllerCheckFormData(id, data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type FormControllerCheckFormDataMutationResult = NonNullable<
  Awaited<ReturnType<typeof formControllerCheckFormData>>
>
export type FormControllerCheckFormDataMutationBody = CheckFormDto
export type FormControllerCheckFormDataMutationError = ErrorType<unknown>

export const useFormControllerCheckFormData = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof formControllerCheckFormData>>,
      TError,
      { id: string; data: CheckFormDto },
      TContext
    >
    request?: SecondParameter<typeof axiosClient>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof formControllerCheckFormData>>,
  TError,
  { id: string; data: CheckFormDto },
  TContext
> => {
  const mutationOptions = getFormControllerCheckFormDataMutationOptions(options)

  return useMutation(mutationOptions, queryClient)
}
export const formControllerActivateForm = (id: string, options?: SecondParameter<typeof axiosClient>) => {
  return axiosClient<FormDto>(
    { url: `https://test-api.detelio.ai/form/activate/${id}`, method: 'PATCH' },
    options,
  )
}

export const getFormControllerActivateFormMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof formControllerActivateForm>>,
    TError,
    { id: string },
    TContext
  >
  request?: SecondParameter<typeof axiosClient>
}): UseMutationOptions<
  Awaited<ReturnType<typeof formControllerActivateForm>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['formControllerActivateForm']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof formControllerActivateForm>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {}

    return formControllerActivateForm(id, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type FormControllerActivateFormMutationResult = NonNullable<
  Awaited<ReturnType<typeof formControllerActivateForm>>
>

export type FormControllerActivateFormMutationError = ErrorType<unknown>

export const useFormControllerActivateForm = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof formControllerActivateForm>>,
      TError,
      { id: string },
      TContext
    >
    request?: SecondParameter<typeof axiosClient>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof formControllerActivateForm>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getFormControllerActivateFormMutationOptions(options)

  return useMutation(mutationOptions, queryClient)
}
export const formControllerDeactivateForm = (id: string, options?: SecondParameter<typeof axiosClient>) => {
  return axiosClient<void>(
    { url: `https://test-api.detelio.ai/form/deactivate/${id}`, method: 'PATCH' },
    options,
  )
}

export const getFormControllerDeactivateFormMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof formControllerDeactivateForm>>,
    TError,
    { id: string },
    TContext
  >
  request?: SecondParameter<typeof axiosClient>
}): UseMutationOptions<
  Awaited<ReturnType<typeof formControllerDeactivateForm>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['formControllerDeactivateForm']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof formControllerDeactivateForm>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {}

    return formControllerDeactivateForm(id, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type FormControllerDeactivateFormMutationResult = NonNullable<
  Awaited<ReturnType<typeof formControllerDeactivateForm>>
>

export type FormControllerDeactivateFormMutationError = ErrorType<unknown>

export const useFormControllerDeactivateForm = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof formControllerDeactivateForm>>,
      TError,
      { id: string },
      TContext
    >
    request?: SecondParameter<typeof axiosClient>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof formControllerDeactivateForm>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getFormControllerDeactivateFormMutationOptions(options)

  return useMutation(mutationOptions, queryClient)
}
export const formControllerFindRevisions = (
  id: string,
  params?: FormControllerFindRevisionsParams,
  options?: SecondParameter<typeof axiosClient>,
  signal?: AbortSignal,
) => {
  return axiosClient<PaginatedFormRevisionDto>(
    { url: `https://test-api.detelio.ai/form/${id}/revisions`, method: 'GET', params, signal },
    options,
  )
}

export const getFormControllerFindRevisionsQueryKey = (
  id?: string,
  params?: FormControllerFindRevisionsParams,
) => {
  return [`https://test-api.detelio.ai/form/${id}/revisions`, ...(params ? [params] : [])] as const
}

export const getFormControllerFindRevisionsQueryOptions = <
  TData = Awaited<ReturnType<typeof formControllerFindRevisions>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  params?: FormControllerFindRevisionsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof formControllerFindRevisions>>, TError, TData>>
    request?: SecondParameter<typeof axiosClient>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getFormControllerFindRevisionsQueryKey(id, params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof formControllerFindRevisions>>> = ({ signal }) =>
    formControllerFindRevisions(id, params, requestOptions, signal)

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof formControllerFindRevisions>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FormControllerFindRevisionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof formControllerFindRevisions>>
>
export type FormControllerFindRevisionsQueryError = ErrorType<unknown>

export function useFormControllerFindRevisions<
  TData = Awaited<ReturnType<typeof formControllerFindRevisions>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  params: undefined | FormControllerFindRevisionsParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof formControllerFindRevisions>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof formControllerFindRevisions>>,
          TError,
          Awaited<ReturnType<typeof formControllerFindRevisions>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof axiosClient>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFormControllerFindRevisions<
  TData = Awaited<ReturnType<typeof formControllerFindRevisions>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  params?: FormControllerFindRevisionsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof formControllerFindRevisions>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof formControllerFindRevisions>>,
          TError,
          Awaited<ReturnType<typeof formControllerFindRevisions>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof axiosClient>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFormControllerFindRevisions<
  TData = Awaited<ReturnType<typeof formControllerFindRevisions>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  params?: FormControllerFindRevisionsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof formControllerFindRevisions>>, TError, TData>>
    request?: SecondParameter<typeof axiosClient>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useFormControllerFindRevisions<
  TData = Awaited<ReturnType<typeof formControllerFindRevisions>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  params?: FormControllerFindRevisionsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof formControllerFindRevisions>>, TError, TData>>
    request?: SecondParameter<typeof axiosClient>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getFormControllerFindRevisionsQueryOptions(id, params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  query.queryKey = queryOptions.queryKey

  return query
}

export const formControllerFindRevision = (
  id: string,
  revisionId: string,
  options?: SecondParameter<typeof axiosClient>,
  signal?: AbortSignal,
) => {
  return axiosClient<FormRevisionDto>(
    { url: `https://test-api.detelio.ai/form/${id}/revisions/${revisionId}`, method: 'GET', signal },
    options,
  )
}

export const getFormControllerFindRevisionQueryKey = (id?: string, revisionId?: string) => {
  return [`https://test-api.detelio.ai/form/${id}/revisions/${revisionId}`] as const
}

export const getFormControllerFindRevisionQueryOptions = <
  TData = Awaited<ReturnType<typeof formControllerFindRevision>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  revisionId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof formControllerFindRevision>>, TError, TData>>
    request?: SecondParameter<typeof axiosClient>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getFormControllerFindRevisionQueryKey(id, revisionId)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof formControllerFindRevision>>> = ({ signal }) =>
    formControllerFindRevision(id, revisionId, requestOptions, signal)

  return { queryKey, queryFn, enabled: !!(id && revisionId), ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof formControllerFindRevision>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FormControllerFindRevisionQueryResult = NonNullable<
  Awaited<ReturnType<typeof formControllerFindRevision>>
>
export type FormControllerFindRevisionQueryError = ErrorType<unknown>

export function useFormControllerFindRevision<
  TData = Awaited<ReturnType<typeof formControllerFindRevision>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  revisionId: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof formControllerFindRevision>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof formControllerFindRevision>>,
          TError,
          Awaited<ReturnType<typeof formControllerFindRevision>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof axiosClient>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFormControllerFindRevision<
  TData = Awaited<ReturnType<typeof formControllerFindRevision>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  revisionId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof formControllerFindRevision>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof formControllerFindRevision>>,
          TError,
          Awaited<ReturnType<typeof formControllerFindRevision>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof axiosClient>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFormControllerFindRevision<
  TData = Awaited<ReturnType<typeof formControllerFindRevision>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  revisionId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof formControllerFindRevision>>, TError, TData>>
    request?: SecondParameter<typeof axiosClient>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useFormControllerFindRevision<
  TData = Awaited<ReturnType<typeof formControllerFindRevision>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  revisionId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof formControllerFindRevision>>, TError, TData>>
    request?: SecondParameter<typeof axiosClient>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getFormControllerFindRevisionQueryOptions(id, revisionId, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  query.queryKey = queryOptions.queryKey

  return query
}

export const formControllerRollbackToRevision = (
  id: string,
  revisionId: string,
  rollbackFormDto: RollbackFormDto,
  options?: SecondParameter<typeof axiosClient>,
  signal?: AbortSignal,
) => {
  return axiosClient<FormDto>(
    {
      url: `https://test-api.detelio.ai/form/${id}/revisions/${revisionId}/rollback`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: rollbackFormDto,
      signal,
    },
    options,
  )
}

export const getFormControllerRollbackToRevisionMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof formControllerRollbackToRevision>>,
    TError,
    { id: string; revisionId: string; data: RollbackFormDto },
    TContext
  >
  request?: SecondParameter<typeof axiosClient>
}): UseMutationOptions<
  Awaited<ReturnType<typeof formControllerRollbackToRevision>>,
  TError,
  { id: string; revisionId: string; data: RollbackFormDto },
  TContext
> => {
  const mutationKey = ['formControllerRollbackToRevision']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof formControllerRollbackToRevision>>,
    { id: string; revisionId: string; data: RollbackFormDto }
  > = (props) => {
    const { id, revisionId, data } = props ?? {}

    return formControllerRollbackToRevision(id, revisionId, data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type FormControllerRollbackToRevisionMutationResult = NonNullable<
  Awaited<ReturnType<typeof formControllerRollbackToRevision>>
>
export type FormControllerRollbackToRevisionMutationBody = RollbackFormDto
export type FormControllerRollbackToRevisionMutationError = ErrorType<unknown>

export const useFormControllerRollbackToRevision = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof formControllerRollbackToRevision>>,
      TError,
      { id: string; revisionId: string; data: RollbackFormDto },
      TContext
    >
    request?: SecondParameter<typeof axiosClient>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof formControllerRollbackToRevision>>,
  TError,
  { id: string; revisionId: string; data: RollbackFormDto },
  TContext
> => {
  const mutationOptions = getFormControllerRollbackToRevisionMutationOptions(options)

  return useMutation(mutationOptions, queryClient)
}
